export const TASTY_SWAP_CARD_WIDTH_PX_DESKTOP = 600;
export const MAX_CONTENT_WIDTH_PX_DESKTOP = 1200;
export const HORIZONTAL_PADDING_PX_DESKTOP = 56;
